import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import AllVendor from '../../component/allvendor/AllVendor';
import UserHeader from '../../component/reusable/UserHeader';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import Cards from '../../component/reusable/Cards';
import AllBomEnqTable from '../../component/bomComps/AllBomEnqTable';
import ToolCards from '../../component/reusable/ToolCards';
import BomStatistics from '../../component/bomComps/BomStatistics';
import BomTab from '../../component/bomComps/BomTab';
import BomFilter from '../../component/bomComps/BomFilter';
import { exportScheduleThunk } from '../../redux/schedulecartslice';
import { deletebomThunk, exportBomThunk, getAllBomThunk, getbomStatisticsThunk, setbomFromDate, setbomPage, setbomSearch, setbomSelectedTab, setbomToDate } from '../../redux/bomSlice';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';


function BomEnquires() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('dsc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);


    // //delete
    const deleteCategory = (password) => {
        dispatch(deletebomThunk({ id: selectedId, password }))
        setIsModalOpen(false);
    }


    // //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };

    const handleChange = (event, newValue) => {
        dispatch(setbomSelectedTab(newValue))
        setAllStatus('')
        dispatch(setbomPage(1))
        dispatch(setbomSearch(''))
        dispatch(setbomFromDate(''))
        dispatch(setbomToDate(''))
    };

    const { bom, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, bomenquiryStatistics } = useSelector((state) => state.bom);
    const bomData = bom?.data
    const totalPages = bom?.totalPages
    const totalItems = bom?.totalItems
    const itemsPerPage = bom?.limit




    useEffect(() => {
        dispatch(getbomStatisticsThunk())
    }, [])

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'QUOTED' : selectedTab === 3 ? 'COMPLETED' : "DELETED"

    // console.log(bom);

    useEffect(() => {
        dispatch(getAllBomThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);


    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportbomenq = async () => {
        const status = await dispatch(exportBomThunk(`?limit=${100000}`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',
                'products': item?.productCount + 'products',
                'Total': item?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "bom")
        }
    }




    return (
        <>
            <UserHeader
                index="BOM Enquiries"
                root="Dashboard"
                exportData={exportbomenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />
            <BomStatistics
                statistics={bomenquiryStatistics}
            />
            <Box>
                <BomTab
                    handleChange={handleChange}
                    selectedTab={selectedTab}
                />
                <BomFilter
                    setAllStatus={setAllStatus}
                    search={search}
                    setSearch={setbomSearch}
                    setFromDate={setbomFromDate}
                    setToDate={setbomToDate}
                    selectedTab={selectedTab}
                />

                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {bomData?.length > 0 ?
                                    <Typography>
                                        <AllBomEnqTable
                                            bomData={bomData}
                                            page={page}
                                            setPage={setbomPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            selectedTab={selectedTab}
                                            enquiryType={"BOM"}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/bom/bomEnquiresDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default BomEnquires;
